module.exports = __webpack_public_path__ + "media/img/patterns/grid-horizontal-rtl-long-dark-888cf7332a1110a46a6e0079d2a7d1ef.png";